<template>
    <game-items-add game-item-variant="skins" @added="redirectToEditPage">
        <template #title>{{ $t('models.add') }}</template>
    </game-items-add>
</template>

<script>
import GameItemsAdd from '@/views/game-items/game-items-add/GameItemsAdd.vue';

export default {
    components: {
        GameItemsAdd,
    },

    methods: {
        redirectToEditPage(response) {
            const { skin_id: skinId = null } = response;

            if (skinId === null) return;

            this.$router.push({
                name: 'skins-edit',
                params: { id: skinId },
            });
        },
    },
};
</script>

<style lang="scss" scoped></style>
